import { addQueryParametersToURL } from "@xapp/chat-widget-core";
import { useContext, useMemo } from "react";
import { SearchWidgetConfigContext } from "./SearchWidgetConfigContext";

export function useSuggestionsUrl(): string {
    const config = useContext(SearchWidgetConfigContext);

    const url = useMemo<string>(() => {
        if (config.suggestionsUrl) {
            try {
                let url = new URL(config.suggestionsUrl);
                const existingParams = new URLSearchParams(url.search);
                // if we already have a key AND key exists, add it.
                if (!existingParams.get("key") && !!config.api.key) {
                    const params = new URLSearchParams(url.search);
                    params.append("key", config.api.key);
                    url = addQueryParametersToURL(config.suggestionsUrl, params);
                }
                return url.toString();
            } catch (e) {
                console.error(`Error parsing suggestions link: ${e}`);
            }
        }
        return "";
    }, [config]);

    return url;
}